<template>
  <div class="login-page">
    <h2>로그인</h2>
    <form @submit.prevent="login">
      <input class="inputInfo" v-model="username" placeholder="사용자 ID" required autocomplete="username" />
      <input
        class="inputInfo"
        v-model="password"
        type="password"
        placeholder="비밀번호"
        required
        autocomplete="current-password"
      />
      <div class="remember-me">
        <input type="checkbox" id="rememberId" v-model="rememberId" />
        <label for="rememberId">아이디 기억</label>
      </div>
      <button type="submit">로그인</button>
      <div v-if="error" class="error">{{ error }}</div>
    </form>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "LoginPage",
  data() {
    return {
      username: "",
      password: "",
      error: "",
      rememberId: false,
    };
  },
  mounted() {
    // 페이지에 들어올 때 기존 로그인 정보 삭제
    localStorage.removeItem("isLogin");
    localStorage.removeItem("userInfo");

    // 아이디 기억 기능: 저장된 아이디와 체크박스 상태를 불러옵니다.
    const savedUsername = localStorage.getItem("savedUsername");
    const rememberId = localStorage.getItem("rememberId");
    if (rememberId === "true" && savedUsername) {
      this.username = savedUsername;
      this.rememberId = true;
    }
  },
  methods: {
    async login() {
      this.error = ""; // 이전 오류 메시지 초기화
      
      // admin 계정 특별 처리 (개발용으로 추정)
      if (this.username === "admin" && this.password === "1234") {
        localStorage.setItem("isLogin", "true");
        // 개발용 admin은 userInfo가 없으므로, 필요하다면 가짜 객체를 만들어 저장할 수 있습니다.
        localStorage.setItem("userInfo", JSON.stringify({ EMP_NM: "관리자", EMP_DEPT_NM: "관리자팀", OGN_FG: "00", userId: "TB관리자" }));
        this.$router.replace("/MovieIndexPage");
        
        return; // API 호출 없이 여기서 종료
      }

      try {
        
        // 아이디와 비밀번호를 백엔드 /api/login 으로 전송합니다.
        const response = await axios.post("/api/login", {
          username: this.username,
          password: this.password,
        });
        
        // 로그인 성공 시 처리
        if (response.data.success) {
          localStorage.setItem("isLogin", "true");

          // 아이디 기억 기능
          if (this.rememberId) {
            localStorage.setItem("savedUsername", this.username);
            localStorage.setItem("rememberId", "true");
          } else {
            localStorage.removeItem("savedUsername");
            localStorage.removeItem("rememberId");
          }

          const userInfo = { ...(response.data.userInfo || {}), userId: this.username };

          localStorage.setItem("userInfo", JSON.stringify(userInfo));
          // console.log(JSON.stringify(response.data.userInfo) + "---->>>>>>>>>this.userInfo");
          if (userInfo.OGN_FG === '01') {
            this.$router.replace("/PrListPage");
          } else {
            this.$router.replace("/BmListPage"); // 페이지로 이동
          }
        } else {
          // API에서 false 를 반환한 경우
          this.error = response.data.message || "아이디 또는 비밀번호가 올바르지 않습니다.";
          alert(this.error);
        }
      } catch (err) {
        // 로그인 실패 시 오류 메시지 표시
        this.error = err.response?.data?.message || "로그인 중 오류가 발생했습니다.";
        alert(this.error);
        console.error("Login failed:", err);
      }
    },
  },
};
</script>

<style scoped>
.login-page {
  max-width: 300px;
  margin: 80px auto;
  padding: 30px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background: #fff;
}
.inputInfo {
  display: block;
  width: 100%;
  margin-bottom: 12px;
  padding: 8px;
  font-size: 1rem;
}
button {
  width: 320px;
  padding: 8px;
  background: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.remember-me {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-size: 0.9rem;
  gap: 5px;
}
.error {
  color: red;
  margin-top: 10px;
}
</style>
